// Co smí a co dostane uživatel od asistenta — malý modul bez Reactu, aby ho hlavní balík (pole hledání v hlavičce)
// mohl načíst, aniž by s ním přišel celý panel (`PanelAsistenta.tsx` se stahuje až při prvním otevření).
import type { Ja } from '@ecoser/shared';

/** Příklady dotazů (prototyp „ZKUSTE NAPŘÍKLAD“) — jen funkce, které aplikace už umí. */
export const PRIKLADY_DOTAZU = [
  'Je odpad 13 02 05 povolený na zařízení CZL00673?',
  'Najdi zaměstnance Roubal',
  'Nastav výchozí splatnost faktur na 14 dní',
  'Která zařízení máme s mostní váhou?',
];

/**
 * Příklady pro řidiče, skladníka a mlynáře — asistent jim nabízí jen nástroje práce v terénu (rozhodnutí 4. 10. 2026,
 * backend `asistent/nastroje/teren.ts`), takže kancelářské příklady by skončily odmítnutím.
 */
export const PRIKLADY_DOTAZU_TEREN = [
  'Co mám dnes?',
  'Jaký je to kód odpadu? Zbytky barev z lakovny v plechovkách',
  'Odeslalo se všechno z tabletu?',
];

const ROLE_JEN_TEREN = new Set(['ridic', 'skladnik', 'mlynar']);

/** Příklady podle role (všechny role účtu terénní → příklady z terénu). */
export function prikladyDotazu(ja: Ja): readonly string[] {
  const role = ja.role_efektivni || ja.role;
  return role && ROLE_JEN_TEREN.has(role) ? PRIKLADY_DOTAZU_TEREN : PRIKLADY_DOTAZU;
}

/**
 * Uživatel smí asistenta (08 §3.18 asistent.pouzit — rozhodnutí 13. 9. noc; od 4. 10. 2026 bez řidiče, skladníka
 * a mlynáře, ti mají jen poradce zařazení odpadu).
 */
export function smiAsistenta(ja: Ja): boolean {
  return (ja.akce ?? []).includes('asistent.pouzit') || (ja.sekce ?? []).includes('asistent');
}
